import { useEffect, useState } from "react";
import { Form, Select } from "antd";

interface SelectProps {
    size?: "large" | "middle" | "small";
    handler: (value: string[]) => void; // Atualizado para receber múltiplos valores
    isRequired?: boolean;
    disabled?: boolean;
    enableSelectAll?: boolean;
    selectAllLabel?: string;
}

const SelectField = (props: SelectProps) => {
    const [options, setOptions] = useState<{ value: string; label: string }[]>([]);
    const form = Form.useFormInstance();
    const SELECT_ALL_VALUE = "__ALL__";

    useEffect(() => {
        // Função para buscar estados da API do IBGE
        const fetchEstados = async () => {
            try {
                const response = await fetch("https://servicodados.ibge.gov.br/api/v1/localidades/estados");
                const data = await response.json();
                
                // Mapeia o resultado para o formato do componente Select
                const estadosOptions = data
                .map((estado: any) => ({
                    value: estado.sigla,
                    label: estado.nome,
                })).sort((a, b) => a.label.localeCompare(b.label));

                setOptions(
                    props.enableSelectAll
                        ? [
                            { value: SELECT_ALL_VALUE, label: props.selectAllLabel ?? "Selecionar todos" },
                            ...estadosOptions,
                        ]
                        : estadosOptions
                );
            } catch (error) {
                console.error("Erro ao buscar estados:", error);
            }
        };

        fetchEstados();
    }, [props.enableSelectAll, props.selectAllLabel]);

    const handleChange = (value: string[]) => {
        if (props.enableSelectAll && value.includes(SELECT_ALL_VALUE)) {
            const allValues = options
                .filter((o) => o.value !== SELECT_ALL_VALUE)
                .map((o) => o.value);
            form?.setFieldValue("uf", allValues);
            props.handler(allValues);
            return;
        }
        props.handler(value);
    };

    return (
        <Form.Item
            name="uf"
            label="UF"
            colon={false}
            rules={[{ required: props.isRequired, message: "Campo obrigatório" }]}
        >
            <Select
                size={props.size}
                options={options}
                mode="multiple" // Permite seleção múltipla
                placeholder="Selecionar estados"
                onChange={handleChange}
                disabled={props.disabled}
                maxTagCount="responsive"
                filterOption={(input, option) => {
                    const normalizeText = (text: string) => 
                      text.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase(); 
                  
                    const optLabel = String((option as any)?.label ?? "");
                    const optValue = String((option as any)?.value ?? "");
                    return (
                        normalizeText(optLabel).startsWith(normalizeText(input)) ||
                        normalizeText(optValue).startsWith(normalizeText(input))
                    );
                  }}
                  
            />
        </Form.Item>
    );
};

export default SelectField;
